module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/shoals.837974b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/shoals.jpg
// module id = hFzO
// module chunks = 0